import React, { FC } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Banner from './atoms/Banner';
import Menu from './organisms/Menu';
import { IPrizeMerchant } from './types';

interface HeaderProps {
  merchant: IPrizeMerchant;
}

const Header: FC<HeaderProps> = ({ merchant }) => (
  <>
    <Menu merchant={merchant} />

    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Banner alt={merchant.name} src={merchant.bannerImageUrl} />} />
      </Routes>
    </BrowserRouter>
  </>
);

export default Header;
